import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { RiTiktokFill } from 'react-icons/ri'
import { FaXTwitter } from 'react-icons/fa6'
import { SvgIconProps } from '@mui/material'
import { FC } from 'react'
import { CampaignSnsRequirementSnsKind } from '~/lib/types/Campaign'
import { SnsConnectProviderKind } from '~/lib/types/SnsConnect'
import { CampaignSnsRequirementSnsType } from '~/generated/graphql'

type Props = {
  provider?: SnsConnectProviderKind
  snsType?: CampaignSnsRequirementSnsKind | CampaignSnsRequirementSnsType | null
  size?: number
  color?: string
} & Omit<SvgIconProps, 'size' | 'color'>

export const SnsIcon: FC<Props> = ({ size = 24, snsType, provider, color, ...props }) => {
  if (!snsType && !provider) {
    throw Error('SnsIconにはproviderかsnsTypeのどちらかを指定してください')
  }

  const youtube = <YouTubeIcon style={{ width: size, height: size, color: color ?? '#fe0400' }} {...props} />
  const twitter = <FaXTwitter style={{ width: size, height: size, color: color ?? '#000' }} {...props} />
  const instagram = <InstagramIcon style={{ width: size, height: size, color: color ?? '#D93177' }} {...props} />
  const tiktok = <RiTiktokFill style={{ width: size, height: size, color: color ?? '#000' }} {...props} />

  if (provider) {
    switch (provider) {
      case SnsConnectProviderKind.Youtube:
        return youtube
      case SnsConnectProviderKind.Twitter:
        return twitter
      case SnsConnectProviderKind.Instagram:
        return instagram
      case SnsConnectProviderKind.TikTok:
        return tiktok
      default:
        return <></>
    }
  }

  if (snsType) {
    switch (snsType) {
      case CampaignSnsRequirementSnsKind.Youtube:
      case CampaignSnsRequirementSnsType.Youtube:
        return youtube
      case CampaignSnsRequirementSnsKind.Twitter:
      case CampaignSnsRequirementSnsType.Twitter:
        return twitter
      case CampaignSnsRequirementSnsKind.Instagram:
      case CampaignSnsRequirementSnsType.Instagram:
        return instagram
      case CampaignSnsRequirementSnsKind.TikTok:
      case CampaignSnsRequirementSnsType.Tiktok:
        return tiktok
      default:
        return <></>
    }
  }

  return <></>
}
